import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';
import { MatDialog, MatSnackBar } from '@angular/material';
import { Category } from '../../services/eleview/types/category';
import { ColumnsWithLetter, OwnerByEnum } from '../../services/eleview/types/model';
import { ShowHistoryDialogComponent } from '../show-history-dialog/show-history-dialog.component';
import { EditCategoryDialogComponent, DialogData } from './edit-category-dialog/edit-category-dialog.component';
import { BackFace } from './service/backface';
import { LabelManagerService } from './service/label-manager.service';

@Component({
	selector: 'common-label-manager',
	templateUrl: './label-manager.component.html',
	styleUrls: ['./label-manager.component.scss'],
	providers: [LabelManagerService]
})
export class LabelManagerComponent implements OnInit {
	@HostBinding('class.label-manager') hostClass = true;
	@Input() title: string;
	@Input() set eleName(val: string) {
		this.svr.eleName = val;
	}
	@Input() set ownerBy(val: OwnerByEnum) {
		this.svr.ownerBy = val;
	}
	@Input() set owner(val: string) {
		this.svr.owner = val;
	}
	@Input() set allColumnsWithLetter(val: ColumnsWithLetter) {
		this.svr.allColumnsWithLetter = val;
	}
	@Input() set backface(val: BackFace) {
		this.svr.backface = val;
	}
	@Input() hasClose = true;

	@Output() close = new EventEmitter();
	constructor(public svr: LabelManagerService, public dialog: MatDialog, private snackBar: MatSnackBar) {}

	ngOnInit() {
		this.svr.fetchCategories();
	}
	addCategoryClick(): void {
		const dialogRef = this.dialog.open(EditCategoryDialogComponent, {
			width: '360px',
			height: '224px',
			data: {
				name: 'æ°çç±»å«',
				title: 'å¢å æ°çç±»å«'
			}
		});

		dialogRef.afterClosed().subscribe((result: DialogData) => {
			if (result) {
				this.svr.addCategory({ name: result.name }).subscribe(
					() => {},
					err => {
						this.snackBar.open(err, 'ç¡®å®', { duration: 5000 });
					}
				);
			}
		});
	}
	openHisDialog() {
		this.svr.fetchCategoryLabelHis().subscribe(v => {
			this.dialog.open(ShowHistoryDialogComponent, {
				width: '360px',
				data: v,
				position: {
					top: '46px',
					right: '16px'
				}
			});
		});
	}
	drop(event: CdkDragDrop<Category[]>) {
		this.svr.setCategoryPosition(this.svr.categorys[event.previousIndex], event.currentIndex + 1);
	}
	categoryDisplayTitle() {
		switch (this.svr.ownerBy) {
			case OwnerByEnum.ownerByEle:
				return 'ç¼ºç';
			case OwnerByEnum.ownerByDept:
				return `${this.svr.owner}`;
			case OwnerByEnum.ownerByUser:
				return 'ç§æ';
		}
	}
}
